import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { ArrowDown, Star } from 'lucide-react';
interface HeroProps {
  onScrollToPurchase: () => void;
}
export function Hero({
  onScrollToPurchase
}: HeroProps) {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen flex items-center justify-center px-4 py-12 md:py-20" data-id="element-24">
      <div className="max-w-5xl mx-auto text-center" data-id="element-25">
        {/* Título principal */}
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-[#2C4A3E] mb-6 md:mb-8 leading-tight px-2" data-id="element-26">
          <span className="text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-bold text-[#8B4513]" data-id="element-27">
            {t.hero.titleNumber}
          </span>{' '}
          {t.hero.titleText}
        </h1>

        {/* Tagline */}
        <p className="text-xl md:text-2xl lg:text-3xl text-[#8B4513] font-serif italic mb-10 md:mb-12 px-2" data-id="element-28">
          {t.hero.tagline}
        </p>

        {/* Portada del libro */}
        <div className="mb-8 md:mb-10" data-id="element-29">
          <img src="https://cdn.magicpatterns.com/uploads/nBxrSidjbsDSAggLesjYdU/ChatGPT_Image_23_nov_2025,_20_10_54.webp" alt="7 Pasos para Sanar tu Relación con el Dinero" className="w-full max-w-md md:max-w-lg mx-auto shadow-2xl rounded-sm" loading="eager" fetchPriority="high" decoding="async" data-id="element-30" />
        </div>

        {/* Social proof */}
        <div className="flex items-center justify-center gap-3 mb-10 md:mb-12" data-id="element-31">
          <div className="flex gap-1" data-id="element-32">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 md:w-6 md:h-6 fill-[#D4A574] text-[#D4A574]" data-id="element-33" />)}
          </div>
          <span className="text-base md:text-lg text-[#2C4A3E] font-semibold" data-id="element-34">
            {t.hero.reviews}
          </span>
        </div>

        {/* CTA button */}
        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.98
      }} onClick={onScrollToPurchase} className="relative px-10 md:px-14 py-5 md:py-6 rounded-full text-lg md:text-xl font-bold transition-all duration-300 mb-12 md:mb-16 text-white overflow-hidden" style={{
        background: '#E4574F',
        border: '1px solid rgba(255, 140, 130, 0.5)'
      }} data-id="element-35">
          <span className="relative z-10" data-id="element-36">{t.hero.cta}</span>
        </motion.button>

        {/* Copy introductorio */}
        <div className="mb-8 md:mb-10 max-w-3xl mx-auto" data-id="element-37">
          <p className="text-lg md:text-xl leading-relaxed text-[#4A4A4A] font-semibold mb-5" data-id="element-38">
            {t.intro.greeting}
          </p>
          <p className="text-base md:text-lg leading-relaxed text-[#4A4A4A]" data-id="element-39">
            {t.intro.p1}
          </p>
        </div>

        {/* Preview en Audio */}
        <div className="mb-0 max-w-lg mx-auto" data-id="element-40">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-41">
            <p className="text-sm uppercase tracking-wider text-[#2C4A3E] font-bold" data-id="element-42">
              {t.hero.listenPreview}
            </p>
            <ArrowDown className="w-4 h-4 text-[#2C4A3E]" strokeWidth={2.5} data-id="element-43" />
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-lg bg-gradient-to-r from-[#2C4A3E] to-[#1F3329] border border-[#D4A574]/30 p-4" data-id="element-44">
            <div className="flex items-center gap-3" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/nBxrSidjbsDSAggLesjYdU/ChatGPT_Image_23_nov_2025,_20_10_54.webp" alt="Album artwork" className="w-12 h-12 rounded-full shadow-md object-cover flex-shrink-0 ring-2 ring-[#D4A574]/50" loading="lazy" data-id="element-46" />
              <audio controls preload="none" className="flex-1 h-10" style={{
              maxWidth: '100%',
              accentColor: '#2C4A3E'
            }} data-id="element-47">
                <source src="https://www.dropbox.com/scl/fi/l15vzwjzkl1rwps6orxtp/wendy-def-1.mp3?rlkey=rox17t1hsa8oxcogrr3c4nait&st=by35vcm1&raw=1" type="audio/mpeg" data-id="element-48" />
                {t.hero.audioFallback}
              </audio>
            </div>
          </div>
        </div>
      </div>
    </section>;
}